import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from './base-api.service';
import { User, PaginatedResponse, ApiResponse } from '@com.maessa.payroll.frontend/models';

export interface UserCreatePayload {
  name: string;
  email: string;
  password: string;
  role: string;
  site_id: number;
  team_id: number | null;
  permissions: string[];
}

export interface PermissionUpdatePayload {
  permissions: string[];
}

@Injectable({ providedIn: 'root' })
export class AdminApiService extends BaseApiService {
  getUsers(filters?: { site_id?: number; role?: string; page?: number }): Observable<PaginatedResponse<User>> {
    const params = this.buildParams(filters ?? {});
    return this.get<PaginatedResponse<User>>(`${this.baseUrl}/admin/users`, params);
  }

  getUser(id: number): Observable<ApiResponse<User>> {
    return this.get<ApiResponse<User>>(`${this.baseUrl}/admin/users/${id}`);
  }

  createUser(payload: UserCreatePayload): Observable<ApiResponse<User>> {
    return this.post<ApiResponse<User>>(`${this.baseUrl}/admin/users`, payload);
  }

  updateUser(id: number, payload: Partial<UserCreatePayload>): Observable<ApiResponse<User>> {
    return this.put<ApiResponse<User>>(`${this.baseUrl}/admin/users/${id}`, payload);
  }

  deactivateUser(id: number): Observable<void> {
    return this.delete<void>(`${this.baseUrl}/admin/users/${id}`);
  }

  updatePermissions(userId: number, payload: PermissionUpdatePayload): Observable<ApiResponse<User>> {
    return this.put<ApiResponse<User>>(
      `${this.baseUrl}/admin/users/${userId}/permissions`,
      payload
    );
  }
}
